export default "__VITE_ASSET__B$rRDtvA__"